// @flow
import * as React from 'react';

import type { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { clickoutRequest, setOrIncrementAdVisitCounter } from '../../../Serp/actions';
import { getPageName } from '../../../Serp/selectors';
import { VERTICAL_NAMES } from '../../constants/common';
import Snippet from '.';
import SnippetCars from '../cars/container';
import SnippetJobs from '../jobs/container';
import SnippetHomes from '../homes/container';
import SnippetProducts from '../products/container';
import { getVerticalName, getCountryCode, getReadingDirection } from '~/common/selectors/config';
import { getAbTest } from '~/common/selectors/trovit';

type OwnProps = {
  ad: Object,
};

type Props = {
  ad: Object,
  lazyLoadImage: boolean,
  wasVisited: boolean,
  withRichData?: ?boolean,
  verticalName: VerticalName,
  countryCode: string,
  readingDirection: string,
  pageName: string,
  wasVisited: boolean,
  dataTestId: string,
  searchParameters: Object,
  trovit: Object,
  onAdClick: Function,
  clickoutRequest: Function,
};

type MapDispatchToProps = {
  clickoutRequest: Function,
  onAdClick: Function,
};

type MapStateToProps = {
  verticalName: VerticalName,
  countryCode?: string,
  readingDirection?: string,
  pageName?: string,
};

export class Component extends React.Component<Props> {
  static defaultProps = {
    lazyLoadImage: false,
    withRichData: false,
  };

  getSnippetByVertical(): React.Node {
    switch (this.props.verticalName) {
      case VERTICAL_NAMES.jobs:
        return <SnippetJobs {...this.props} />;
      case VERTICAL_NAMES.homes:
        return <SnippetHomes {...this.props} />;
      case VERTICAL_NAMES.products:
        return <SnippetProducts {...this.props} />;
      case VERTICAL_NAMES.cars:
        return <SnippetCars {...this.props} />;
      default:
        return null;
    }
  }

  handleItemClick = (e: SyntheticEvent<HTMLButtonElement>) => {
    e.preventDefault();
    this.props.clickoutRequest();

    if (typeof this.props.onAdClick === 'function') {
      this.props.onAdClick();
    }
  };

  render() {
    return (
      <Snippet {...this.props} onItemClicked={this.handleItemClick}>
        {this.getSnippetByVertical()}
      </Snippet>
    );
  }
}

export function mapDispatchToProps(dispatch: Dispatch<*>, { ad }: OwnProps): MapDispatchToProps {
  return {
    clickoutRequest: () => dispatch(clickoutRequest(ad)),
    onAdClick: () => dispatch(setOrIncrementAdVisitCounter(ad.id)),
  };
}

export function mapStateToProps(state: any): MapStateToProps {
  return {
    verticalName: getVerticalName(state),
    countryCode: getCountryCode(state),
    readingDirection: getReadingDirection(state),
    testAb: getAbTest(state),
    pageName: getPageName(state),
  };
}

const SnippetContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);

SnippetContainer.displayName = 'SnippetContainer';

export default SnippetContainer;



// WEBPACK FOOTER //
// ./app/common/Snippet/shared/container.js